export function asArray(value) {
  if (Array.isArray(value)) return value.filter((item) => item != null);
  if (value == null) return [];
  return [value];
}

export function asText(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  if (Array.isArray(value)) {
    return value.map((item) => asText(item)).filter(Boolean).join(" ");
  }
  return "";
}

export function getReportBody(data) {
  if (!data || typeof data !== "object") return {};
  return data.report && typeof data.report === "object" ? data.report : data;
}

export function getWorkbook(data) {
  if (!data || typeof data !== "object") return {};
  return data.workbook && typeof data.workbook === "object" ? data.workbook : data;
}

export function getMeta(data) {
  return data?.meta || data?.gameMeta || {};
}

export function getExecutiveBrief(data) {
  const report = getReportBody(data);
  return data?.executiveBrief || report.executiveBrief || {};
}

export function formatPriority(value) {
  const text = asText(value).trim();
  if (!text) return "";
  return text.replace(/_/g, " ");
}

export function priorityTone(value) {
  const text = asText(value).toLowerCase();
  if (text.includes("critical") || text === "high") return "high";
  if (text === "medium" || text === "major") return "medium";
  if (text === "low" || text === "minor") return "low";
  return "neutral";
}

export function evidenceText(evidence) {
  if (!evidence) return "";
  if (typeof evidence === "string") return evidence;
  return (
    asText(evidence.sample) ||
    asText(evidence.excerpt) ||
    asText(evidence.reference) ||
    asText(evidence.sessionRef) ||
    asText(evidence.windowRange) ||
    ""
  );
}

export function scoringLabel(scoring) {
  if (!scoring || typeof scoring !== "object") return "";
  return asText(scoring.label) || asText(scoring.scope);
}

export function timelineHasEnergy(timeline) {
  const points = asArray(timeline);
  if (!points.length) return false;
  if (points.some((point) => point && Object.prototype.hasOwnProperty.call(point, "energyMeasured"))) {
    return points.some((point) => point?.energyMeasured === true);
  }
  return points.some((point) => {
    const value = Number(point?.energy ?? point?.arousalNorm ?? point?.momentum);
    return (Number.isFinite(value) && value > 0) || point?.interpolated === false;
  });
}

export function downsample(points, maxPoints = 80) {
  if (!Array.isArray(points) || points.length <= maxPoints) return points || [];
  const step = Math.ceil(points.length / maxPoints);
  return points.filter((_, index) => index % step === 0 || index === points.length - 1);
}

export function getReportAssetBaseUrl(fileUrl) {
  if (!fileUrl) return "";
  try {
    const parsed = new URL(fileUrl);
    const slash = parsed.pathname.lastIndexOf("/");
    parsed.pathname = slash >= 0 ? `${parsed.pathname.slice(0, slash + 1)}` : parsed.pathname;
    parsed.search = "";
    parsed.hash = "";
    return parsed.toString();
  } catch (error) {
    return "";
  }
}

export function getClipPath(value) {
  if (!value) return "";
  if (typeof value === "string") return value;
  return (
    asText(value.clipPath) ||
    asText(value.videoPath) ||
    asText(value.clipUrl) ||
    asText(value.videoUrl) ||
    asText(value.src) ||
    ""
  );
}

export function resolveMediaUrl(path, assetBaseUrl) {
  const text = asText(path).trim();
  if (!text || /^\[media redacted\]$/i.test(text)) return null;
  if (text.startsWith("https://") || text.startsWith("http://")) return text;
  if (text.startsWith("gs://")) {
    return `https://storage.googleapis.com/${text.slice(5)}`;
  }
  if (!assetBaseUrl) return null;
  try {
    return new URL(text.replace(/^\.\//, ""), assetBaseUrl).toString();
  } catch (error) {
    return null;
  }
}

export function metricValue(value) {
  if (value == null || value === "") return "—";
  if (typeof value === "number") {
    return Number.isInteger(value) ? String(value) : value.toFixed(1);
  }
  return asText(value) || "—";
}
